import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

class RequestFormPreviousFile extends Component {
  render() {
    const { original_name } = this.props.formData || {};
    const { schema } = this.props;

    return (
      <div className="flex flex-col mb-3">
        {schema.title && (
          <label className="mb-1 mt-[0.3vh] inline-block font-['Open_Sans'] text-[12px] font-bold text-[#212529]">
            <FormattedMessage id={schema.title} />
          </label>
        )}
        
        <div className="w-full">
          <input
            disabled
            readOnly
            value={original_name || ''}
            data-cy={`${String(schema?.title).toLowerCase()}-original-name`}
            className="w-full bg-[#efefef] border border-[#ced4da] rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] font-semibold font-['Open_Sans'] text-[rgba(0,0,0,0.38)] cursor-not-allowed"
          />
        </div>
      </div>
    );
  }
}

RequestFormPreviousFile.propTypes = {
  formData: PropTypes.object,
  schema: PropTypes.object.isRequired,
};

RequestFormPreviousFile.defaultProps = {
  formData: {},
};

export default RequestFormPreviousFile;
